import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';

export interface ILineItem {
  hubspotProductId: string;
  productType: string;
  name: string;
  quantity: number;
  price: number;
  discount: number;
}

export enum DealTypes {
  SubscriptionRenewal = 'SUBSCRIPTION_RENEWAL',
  SubscriptionUpgrade = 'SUBSCRIPTION_UPGRADE',
  LicenseAddition = 'LICENSE_ADDITION',
  ManagedPanel = 'MANAGED_PANEL',
  ServicesProject = 'SERVICES_PROJECT', // Research service project
  BulkCredits = 'BULK_CREDITS',
  SubscriptionSingUp = 'SUBSCRIPTION_SIGN_UP',
  Pilot = 'PILOT',
}

export interface IDeal {
  internalId: string;
  dealName: string;
  isClosedWonStage?: boolean;
  closeDate?: Date;
  contractStartDate?: Date;
  lineItems: ILineItem[];
  amount: number;
  dealType: DealTypes;
  dealTypeDescription: string;
}

export interface IFetchDealsRequest {
  filterBy: {
    invoiced: boolean;
    dealTypes: DealTypes[];
    companyHubspotId?: string;
    accountSightXId?: string;
  };
}

export const fetchHubspotAccountDeals: AsyncThunk<
  { deals: IDeal[] },
  IFetchDealsRequest,
  ThunkAPI
> = createAsyncThunk(
  'accounts/fetchHubspotDealsByCompany',
  (data: IFetchDealsRequest, thunk) => {
    return apiAsyncThunkCreator<{ deals: IDeal[] }, IFetchDealsRequest>({
      endpoint: 'crm/deals/filter-by',
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Post
    })(data, thunk);
  }
);
